import { Controller } from "@hotwired/stimulus"

// Polling di riserva di un'analisi in background (come pollAnalysisJob di api.js):
// legge l'endpoint `…-status` ogni `interval` ms, al massimo `maxAttempts` volte.
// {status: "done"}  -> evento `analysis-poll:done` (detail: {result, data}) e, se c'è `frame`, ricarica il Turbo Frame
// {status: "error"} -> evento `analysis-poll:error` (detail: {error: "analysis-failed", data})
// errori di rete    -> ignorati fino a maxAttempts; poi `analysis-poll:error` con error "timeout"
//
// Toast dell'esito (onDone/onError dell'originale), prima dell'evento: `doneToast` con done; `errorToast` con error e
// timeout, oppure, con `errorDetail`, `data.error` se c'è ((data && data.error) || … di ReadinessScore).
//
//   <div data-controller="analysis-poll" data-analysis-poll-url-value="/api/projects/1/readiness-status"
//        data-analysis-poll-frame-value="readiness"></div>
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 },
    maxAttempts: { type: Number, default: 60 },
    frame: String,
    doneToast: String,
    errorToast: String,
    errorDetail: Boolean
  }

  connect() {
    this.attempts = 0
    this.stopped = false
    this.timer = setTimeout(() => this.tick(), this.intervalValue)
  }

  disconnect() {
    this.stop()
  }

  stop() {
    this.stopped = true
    clearTimeout(this.timer)
  }

  async tick() {
    if (this.stopped) return
    this.attempts += 1
    try {
      const res = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data = await res.json()
      if (this.stopped) return
      if (data.status === "done") return this.finish("done", { result: data.result, data })
      if (data.status === "error") return this.finish("error", { error: "analysis-failed", data })
    } catch (e) {
      // errore transitorio di rete/proxy: si continua fino a maxAttempts
    }
    if (this.stopped) return
    if (this.attempts >= this.maxAttemptsValue) return this.finish("error", { error: "timeout", data: null })
    this.timer = setTimeout(() => this.tick(), this.intervalValue)
  }

  finish(esito, detail) {
    this.stop()
    if (esito === "done" && this.doneToastValue) window.toast?.success(this.doneToastValue)
    if (esito === "error" && this.errorToastValue) {
      window.toast?.error((this.errorDetailValue && detail.data?.error) || this.errorToastValue)
    }
    this.dispatch(esito, { detail })
    if (esito === "done" && this.hasFrameValue && this.frameValue) {
      document.getElementById(this.frameValue)?.reload?.()
    }
  }
}
